let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eAdlV")).then(() => parcelRequire('16ReN'));